//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useContext } from 'react';
import styles from './style.module.scss';
import cn from 'classnames';
import { ReactComponent as ActiveSVG } from '../../../assets/images/check.svg';
import { ReactComponent as InactiveSVG } from '../../../assets/images/Subtract.svg';
import { Text } from '../../typography/Text/Text';
import { MultiImageSelectContext } from './context';

interface ImageOptionProps {
  value: string;
  image: string;
  label: string;
  className?: string;
}

export const ImageOption: React.FC<ImageOptionProps> = ({
  value,
  image,
  label,
  className = '',
}) => {
  const { handleChange, currentValue } = useContext(MultiImageSelectContext);

  const isActive = currentValue.findIndex((v) => v === value) !== -1;

  return (
    <div
      className={cn(styles.multiOption, { [styles.multiActive]: isActive })
      }
      onClick={() => {
        handleChange(value);
      }}
    >
      <div className={styles.imageContainer}>
        <img src={image} alt={label} className={styles.imageOption} />
      </div>
      <div className={styles.optionLabel}>
        <Text semibold className={styles.optionText}>
          {label}
        </Text>
        {currentValue.findIndex((v) => v === value) !== -1 ? (
          <ActiveSVG />
        ) : (
          <InactiveSVG />
        )}
      </div>
    </div>
  );
};
